import moment from 'moment-mini';

const pt = {
  weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  weekdaysLong: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril',
    'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
};

export default {
  /* short(dateTime, language) {},
  shortWithWeekday(dateTime, language) {},
  long(dateTime, language) {}, */
  longWithTime(dateTime, language) {
    const date = moment(dateTime);
    if (language === 'pt') {
      return `${pt.weekdaysLong[date.format('d')]}, ${date.format('D')} de ${pt.monthNames[date.format('M') - 1]} de ${date.format('YYYY [às] HH[h]mm')}`;
    }
    return date.format('dddd, Do MMMM YYYY [at] HH[h]mm');
  },

  shortWithTime(dateTime, language) {
    const date = moment(dateTime);
    if (language === 'pt') {
      return `${pt.weekdaysShort[date.format('d')]}, ${date.format('D')} de ${pt.monthNamesShort[date.format('M') - 1]} de ${date.format('YYYY [às] HH[h]mm')}`;
    }
    return date.format('ddd, Do MMM YYYY [at] HH[h]mm');
  },

  short(dateTime, language) {
    const date = moment(dateTime);
    if (language === 'pt') {
      return `${pt.weekdaysShort[date.format('d')]}, ${date.format('D')} de ${pt.monthNamesShort[date.format('M') - 1]} de ${date.format('YYYY')}`;
    }
    return date.format('ddd, Do MMM YYYY');
  },

  duration(minutes, language) {
    let humanDuration = moment.duration(minutes, 'minutes').humanize();
    if (language === 'pt') {
      humanDuration = humanDuration.replace('hours', 'horas')
        .replace('minutes', 'minutos')
        .replace('days', 'dias')
        .replace('an hour', 'uma hora')
        .replace('a day', 'um dia');
    }
    return humanDuration;
  },
  toNow(dateTime) {
    const date = moment(dateTime);
    return date.toNow(true);
  },
};



// WEBPACK FOOTER //
// ./src/lib/formatTime.js